const products = require('./virtual-mirror-products.js')[blz.organizationId];
var blzEvent = require('../services/tracking/blz-event.js');

const Methods = {
  init() {
    if (!document.querySelector('.YMK-app')) return;
    this.YMKScript();
    this.setProducts();
    this.showChecked();
    this.showSkus();
    this.selectedProduct();
    this.scrollTo();
  },
  YMKScript() {
    (function (d, k) {
      var s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = products.src + k;
      var x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    })(window.document, products.token);
    (function () {
      if (window.innerWidth < 480) {
        var IMKModule = document.querySelector('#YMK-module');
        if (IMKModule) {
          IMKModule.style.width = window.innerWidth * 1.1;
          IMKModule.style.height = '100%';
          IMKModule.style.backgroundColor = '#C3C3C3';
        }
      }
    });
    window.ymkAsyncInit = function () {
      window.YMK.init({
        autoOpen: true,
        language: 'ptb',
        skinSmoothStrength: 0
      });
      window.YMK.open();
    };
  },
  setProducts() {
    var productSku = document.querySelectorAll('.YMK-sku-wrapper');
    (products.list || []).forEach((product) => {
      (productSku || []).forEach((skuProduct) => {
        skuProduct.addEventListener('click', function (event) {
          if (event.target.parentNode.classList.contains('active-sku')) return;
          const active = event.currentTarget.querySelector('.active-sku');
          if (active) {
            active.classList.remove('active-sku');
            event.target.parentNode.classList.add('active-sku');
          } else {
            event.target.parentNode.classList.add('active-sku');
          }

          blzEvent.interaction(
            {},
            {
              category: (blz.pageName || '').toUpperCase(),
              action: 'Button-Click',
              label: 'Virtual-Mirror',
              values: product['Product Name']
            }
          );
        });
        if (product['Product Name'] == skuProduct.dataset.productname) {
          var newProduct = document.createElement('input');
          var labelWrapper = document.createElement('label');
          labelWrapper.setAttribute('for', product['SKU ID']);
          labelWrapper.style.backgroundColor = product['Color Code'];
          newProduct.setAttribute('type', 'radio');
          newProduct.setAttribute('id', product['SKU ID']);
          newProduct.setAttribute('value', product['SKU Name']);
          newProduct.setAttribute('data-guid', product['Item GUID']);
          newProduct.setAttribute('name', product['Product Type']);
          newProduct.setAttribute('class', 'sku');
          newProduct.setAttribute('data-name', product['Product Name']);
          newProduct.setAttribute('data-look', product['Product Look']);
          skuProduct.append(labelWrapper);
          labelWrapper.append(newProduct);
          newProduct.addEventListener('change', function () {
            if (this.getAttribute('data-look') != 'undefined') {
              window.YMK.applyMakeupByLook(this.dataset.look);
            } else window.YMK.applyMakeupBySku(this.dataset.guid);
          });
        }
      });
    });
  },
  showChecked() {
    var category = document.querySelectorAll('.YMK-category-check') || [];
    var categoryWrapper = document.querySelectorAll('.YMK-product-wrapper') || [];
    category.forEach((cat) => {
      categoryWrapper.forEach((wrapper) => {
        cat.addEventListener('change', function () {
          if (cat.dataset.type == wrapper.dataset.type) {
            wrapper.classList.add('active');
            document.querySelector('.YMK-product-category label.active').classList.remove('active');
            cat.parentNode.classList.add('active');
          } else {
            wrapper.classList.remove('active');
            // cat.parentNode.classList.remove('active')
          }
        });
      });
    });
  },
  showSkus() {
    var prod = document.querySelectorAll('.YMK-product-sku input') || [];
    var skus = document.querySelectorAll('.YMK-sku-wrapper') || [];
    prod.forEach((prd) => {
      prd.addEventListener('change', function () {
        skus.forEach((sku) => {
          if (sku.dataset.productname == prd.id) {
            sku.classList.add('active');
            document.querySelector('.content-button.active').classList.remove('active');
            prd.parentNode.parentNode.classList.add('active');
            sku.firstChild.firstChild.click();
            return true;
          } else {
            sku.classList.remove('active');
            // prd.parentNode.parentNode.classList.remove("active")
            return false;
          }
        });
      });
    });
  },

  selectedProduct() {
    var allInputs = document.querySelectorAll('.YMK-sku-wrapper label input') || [];
    var selectedProduct = document.querySelector('.YMK-selected-product') || {};
    allInputs.forEach((input) => {
      input.addEventListener('change', function () {
        selectedProduct.textContent = input.dataset.name + ' - ' + input.value;
      });
    });
  },

  scrollTo() {
    var width = document.body.clientWidth;
    var virtualMirrorPage = document.getElementById('virtual-mirror-page');
    if (width < 560 && virtualMirrorPage) {
      virtualMirrorPage.scrollIntoView();
    }
  }
};
Methods.init();
